export class CreditRequestBankReferenceInformation {
    DRB_Fecha_inicio_relacion: string;
    DRB_Nombre_encargado_confirmar: string;
    DRB_Nombre_institucion: string;
    DRB_Telefono: string;
    DRB_Telefono_Extension: string;
    DRB_Tip_relacion: string;
    valid: boolean;

    constructor() {
        this.DRB_Fecha_inicio_relacion = "";
        this.DRB_Nombre_encargado_confirmar = "";
        this.DRB_Nombre_institucion = "";
        this.DRB_Telefono = "";
        this.DRB_Telefono_Extension = "";
        this.DRB_Tip_relacion = "";
        this.valid = false;
    }
}